import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { appearingAnimation } from "../../../../shared/styles";

export const RejectionErrorsContainer = styled.div`
    display: flex;
    flex-direction: column;

    box-sizing: border-box;
    width: 100%;
    margin-bottom: 32px;
    padding: 16px;

    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: ${Colors.Black.V200};

    background: ${Colors.WHITE};
    border: 1px solid ${Colors.Red.V50};
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 4%);

    animation: ${appearingAnimation} 150ms ease;
`;

export const RejectionHeader = styled.h3`
    padding-bottom: 12px;
    font-weight: 500;
`;

export const RejectionInfo = styled.span`
    padding-bottom: 16px;
`;

export const RejectionReasonsHeader = styled.h3`
    padding-bottom: 4px;
    font-weight: 500;
`;

export const RejectionMessagesList = styled.ul`
    padding-left: 16px;
    color: ${Colors.Red.V150};
`;

export const RejectionReasonItem = styled.span`
    position: relative;
    left: -5px;
    padding-bottom: 4px;
`;
